/*
 * Copyright (c) 2017 Payoneer Germany GmbH. All rights reserved.
 */

/**
 * Separate the logic of Ajax calls
 *
 * @param system object
 * 	url {String} the end point url,
 * 	data {String} eg: stringified json,
 * 	type {String} eg: "GET" or "POST" or "DELETE",
 * 	dataType {String} eg: "json",
 * 	contentType {String} eg: "application/x-www-form-urlencoded; charset=UTF-8"
 *
 * @return object with 2 methods on it (fail(err) and done(data))
 */
var $ = require('jquery');

function ajaxAdapter(system) {
    return $.ajax(system);
}

module.exports = ajaxAdapter;
